import chroma from 'chroma-js';

const styles = (theme) => ({
  root: {
    '& + [class*="Tabs-root"]': {
      marginTop: theme.spacing(4),
    },
  },
  tabs: {
    position: 'relative',

    '& .MuiTabs-indicator': {
      height: 2,
      backgroundColor: theme.palette.primary.main,
    },

    '& .MuiTab-root': {
      '&.Mui-selected': {
        '& .MuiSvgIcon-colorError': {
          backgroundColor: (props) => (props.light ? 'white' : theme.palette.primary.main),
        },
      },

      '&:not(.Mui-selected):hover': {
        '& .MuiSvgIcon-colorError': {
          backgroundColor: (props) => (props.light ? 'white' : chroma(theme.palette.primary.main).brighten(0.5)),
        },
      },
    },
  },
  label: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightMedium,
  },
  labelCount: {
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(11),
  },
  iconError: {
    marginLeft: 3,
    marginRight: 0,
    fontSize: theme.typography.pxToRem(16),
    backgroundColor: 'white',
  },
  scrollButtons: {
    ...theme.mixins.tab.scroll.buttons,
  },
});

export default styles;
